import axios from 'axios';
import { MortalityProfile } from 'views/bluviu-nutrition/features/scenarios-v2/types/mortality-profile';

//we still dont know how we are going to fetch this data, so for now we will return the mock data, but this will be replaced with an api call in the future
export const getMortalityProfiles = async (
  marketId: string,
  globalCompanyId: string,
  globalSiteId: string
): Promise<MortalityProfile[]> => {
  const res = await axios.get<MortalityProfile[]>(
    `/ewosapi/v1/scenarios/gt2-multi/markets/${marketId}/mortality-profiles?globalCompanyId=${globalCompanyId}&globalSiteId=${globalSiteId}`
  );

  return res.data;
};
